$(function () {
    var pagetop = $('.p-footer-pagetop');
    pagetop.hide();
    $(window).on('scroll',function (){
        if ($(this).scrollTop() > 500) {
            pagetop.fadeIn();
        } else {
            pagetop.fadeOut();
        }
    });
});